<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="series-real">
        <template slot="header">
          <el-form inline :model="queryParams" size="small">
            <el-form-item :label="$t('text.cjqxlh')">
              <el-input
                v-model="queryParams.gatewaysn"
                clearable
                :placeholder="$t('text.cjqxlh')"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item :label="$t('text.nbqxlh')">
              <el-input
                v-model="queryParams.sn"
                clearable
                :placeholder="$t('text.nbqxlh')"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <el-table
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            height="calc(100% - 50px)"
            fit
            :data="tablist"
          >
            <template slot="empty">
              <div class="table-no-data" />
            </template>
            <el-table-column
              align="center"
              :label="$t('text.cjqxlh')"
              prop="gatewaysn"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.nbqxlh')"
              prop="sn"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.slave_address')"
              prop="slaveaddr"
              show-overflow-tooltip
            />
            <el-table-column
              align="center"
              :label="$t('text.zlsr')"
            >
              <el-table-column
                align="center"
                :label="$t('text.td')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3)" :key="item" class="row-tr">
                    <span>{{ item | pvFilter(scope.row.pvnum) }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dy')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ scope.row['vpv' + item] }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.current')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ scope.row['ipv' + item] }}</span>
                  </tr>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('text.jlsc')"
            >
              <el-table-column
                align="center"
                :label="$t('text.xw')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ item | lFilter }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dy')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr class="row-tr">
                    <span>{{ scope.row.vac1 | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.vac2 | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.vac3 | nullFilter }}</span>
                  </tr>
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3) - 3" :key="item" class="row-tr">
                    <span>--</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.current')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr class="row-tr">
                    <span>{{ scope.row.iac1 | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.iac2 | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.iac3 | nullFilter }}</span>
                  </tr>
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3) - 3" :key="item" class="row-tr">
                    <span>--</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.gonglv')"
                class-name="row-column"
                prop="pac"
              />
              <el-table-column
                align="center"
                :label="$t('text.pl')"
                prop="fac"
                :formatter="$elFormatter"
              />
            </el-table-column>

            <el-table-column
              align="center"
              :label="$t('text.zongdl')"
              prop="etotal"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.wendu')"
              prop="temperature"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.shijian')"
              prop="sitetime"
              width="100px"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              label="操作"
            >
              <template v-slot="scope">
                <el-button type="text" icon="el-icon-box" @click="getTable(scope.row)">汇流箱</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            layout="total, prev, pager, next"
            background
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="GetClusterData"
          />
        </template>
      </el-card>

      <el-dialog
        title="汇流箱表格数据"
        destroy-on-close
        append-to-body
        custom-class="combiner-box__dialog"
        :visible.sync="showVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <table border="1" style="width: 100%;">
          <caption>汇流箱表格数据</caption>
          <tbody>
            <tr>
              <td><span>汇流箱序号</span></td>
              <td v-for="num in PVnum" :key="num"><span>{{ num }}</span></td>
            </tr>
            <tr>
              <td><span>电压</span></td><td v-for="child in PVnum" :key="child"><span>{{ row['vpv' + child] }}</span></td>
            </tr>
            <tr>
              <td><span>电流</span></td><td v-for="child in PVnum" :key="child"><span>{{ row['ipv' + child] }}</span></td>
            </tr>
            <tr>
              <td><span>功率</span></td>
              <td v-for="child in PVnum" :key="child">
                <span>{{ (parseFloat(row['vpv' + child])*parseFloat(row['ipv' + child])) | Decimal }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <template slot="footer">
          <el-button type="primary" @click="showVisible = false">确定</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { QueryClusterStationReal } from '@/api/Stations'
import { GetSolarPvNum } from '@/api/Device'
export default {
  name: 'Realtime',
  data () {
    return {
      queryParams: {
        stationid: this.$store.getters.station.id
      },
      pageNum: 1,
      pageSize: 2,
      total: 0,
      tablist: [],
      loading: false,
      totalCount: 0,
      showVisible: false,
      PVnum: '',
      row: ''
    }
  },
  created () {
    this.GetClusterData()
  },
  methods: {
    GetClusterData () {
      this.loading = true
      QueryClusterStationReal({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: 'sn',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.tablist = res.data.queryResults
        this.total = res.data.totalCount
        this.loading = false
      })
    },
    handleQuery () {
      this.pageNum = 1
      this.GetClusterData()
    },
    indexCount (index) {
      return (this.pageNum - 1) * this.pageSize + (index + 1)
    },
    getTable (row) {
      this.row = row
      this.showVisible = true
      GetSolarPvNum({ id: row.devid }).then(res => {
        this.PVnum = res.data.value
      })
    }
  }
}
</script>

<style scoped>
.series-real{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.series-real >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}
.series-real >>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.series-real >>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.series-real >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 15px 10px;
  box-sizing: border-box;
}
.series-real >>> .el-card__body .el-table{
  border: none;
}
.series-real >>> .el-card__body .el-pagination{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style>
.combiner-box__dialog td{
  border-color: #1CC197;
  color: white;
  padding: 5px;
  text-align: center;
}
.combiner-box__dialog td span{
  white-space: nowrap;
}
.combiner-box__dialog caption{
  font-size: 16px;
  font-weight: bold;
  color: #1CC197;
  margin-bottom: 10px;
}
</style>
